import * as React from 'react';
import * as Charts from '@sail/charts';
import {ResizableContainer} from '../common/ResizableContainer';

const sales = [
  {
    date: 'January',
    sold: 10,
  },
  {
    date: 'February',
    sold: 41,
  },
  {
    date: 'March',
    sold: 22,
  },
  {
    date: 'April',
    sold: 38,
  },
];

export const Axis = ({chart}) => {
  const Chart = Charts[chart];
  return (
    <ResizableContainer minWidth={150} width={500} maxWidth={800}>
      <Chart
        data={sales}
        x="date"
        y={{value: 'sold', label: 'Price', format: {currency: 'USD'}}}
      />
    </ResizableContainer>
  );
};
